/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryResponseAdminDto } from '../../models/category-response-admin-dto';
import { CreateCategoryDto } from '../../models/create-category-dto';

export interface AdminCategoriesControllerCreateCategoryV1$Params {
      body: CreateCategoryDto
}

export function adminCategoriesControllerCreateCategoryV1(http: HttpClient, rootUrl: string, params: AdminCategoriesControllerCreateCategoryV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CategoryResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminCategoriesControllerCreateCategoryV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CategoryResponseAdminDto>;
    })
  );
}

adminCategoriesControllerCreateCategoryV1.PATH = '/v1/admin/categories';
